module.exports = __webpack_public_path__ + "img/div4s.655928ce.jpg";